/**
 * AddUserForm Component
 * UI-komponent för att lägga till ny användare
 * Endast rendering + event handlers - all logik i useUserForm hook
 */

import React from 'react';
import { UserFormFields } from './UserFormFields';
import { useUserForm } from '../hooks/useUserForm';

function AddUserForm({ setUsers, users, builders = [], onClose, defaultRole = '', onSuccess }) {
  const {
    values,
    setValues,
    suppliers,
    previewUrl,
    errors,
    isLoading,
    emailSent,
    handleChange,
    handleAvatarChange,
    handleRemoveAvatar,
    handleSubmit
  } = useUserForm({
    initialUser: null,
    onClose,
    onSuccess,
    setUsers,
    users,
    defaultRole,
    isUpdate: false
  });

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-4">
        {defaultRole === 'kund' ? 'Lägg till kund' : 'Lägg till användare'}
      </h2>
      
      {errors.submit && (
        <p className="text-red-500 mb-4">{errors.submit}</p>
      )}
      
      {emailSent && (
        <p className="text-green-500 mb-4">
          Välkomstmail har skickats till användaren!
        </p>
      )}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <UserFormFields
          values={values}
          setValues={setValues}
          errors={errors}
          builders={builders}
          suppliers={suppliers}
          previewUrl={previewUrl}
          handleChange={handleChange}
          handleAvatarChange={handleAvatarChange}
          handleRemoveAvatar={handleRemoveAvatar}
          isUpdate={false}
          showPasswordFields={true}
          showEmailOptions={true}
        />
        
        <div className="flex space-x-4 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 bg-gray-500 text-white p-2 rounded hover:bg-gray-600 
                     transition-colors duration-200"
          >
            Avbryt
          </button>
          <button
            type="submit"
            disabled={isLoading}
            className="flex-1 bg-leadme-pink text-white p-2 rounded hover:bg-leadme-pink-dark 
                     disabled:bg-leadme-pink/50 transition-colors duration-200"
          >
            {isLoading ? 'Sparar...' : 'Spara'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddUserForm;

